var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMultiFamily = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 398.98 355.04"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 5"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 28",
  d: "M334.088 149.488a14.986 14.986 0 01-14.971-15V50.594a14.971 14.971 0 1129.942 0v83.894a14.986 14.986 0 01-14.971 15z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 29",
  d: "M34.65 354.038v-197.4a5.006 5.006 0 011.679-3.74L195.679 11.26a4.982 4.982 0 016.623 0l159.35 141.635a5.008 5.008 0 011.679 3.74v197.403H34.65z",
  fill: "#cdebfc"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 30",
  d: "M361.653 152.895L202.303 11.26a4.983 4.983 0 00-3.312-1.26v344.038h164.341v-197.4a5.008 5.008 0 00-1.679-3.743z",
  fill: "#bfe1fd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 34",
  d: "M383.006 193.562a14.888 14.888 0 01-9.929-3.779L198.991 35.052 24.906 189.783a14.988 14.988 0 01-19.869-22.445L189.057 3.776a14.949 14.949 0 0119.869 0l184.02 163.562a15 15 0 01-9.94 26.221z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 35",
  d: "M392.946 167.338L208.926 3.779A14.919 14.919 0 00198.991 0v35.051l174.088 154.731a14.987 14.987 0 0019.87-22.441z",
  fill: "#d65b72"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36",
  d: "M387.313 355.038H11.666c-6.443-.19-11.667-6.906-11.667-15.19s5.223-15 11.666-15h375.648c6.443 0 11.666 6.716 11.666 15s-5.223 15-11.666 15.19z",
  fill: "#dafcdb"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 37",
  d: "M387.284 323.848H198.991v30.19h188.292c6.46-.192 11.7-6.908 11.7-15.192s-5.237-15-11.7-15z",
  fill: "#b6fcd1"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 110",
  d: "M155.268 167.147a55.3 55.3 0 00-55.278 55.278v22.111a10.949 10.949 0 0011.056 11.056h88.445v-66.338a55.717 55.717 0 00-44.223-22.107z",
  fill: "#d65b72"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 111",
  d: "M298.99 222.425v22.111a10.949 10.949 0 01-11.056 11.056H199.49v-66.338a55.278 55.278 0 0199.5 33.167z",
  fill: "#1f84bd"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 112",
  d: "M199.49 233.48a55.3 55.3 0 00-55.278 55.278 10.949 10.949 0 0011.056 11.056h88.445a10.949 10.949 0 0011.056-11.056 55.3 55.3 0 00-55.279-55.278z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 113",
  d: "M254.767 288.758a10.949 10.949 0 01-11.056 11.056h-44.222V233.48a55.3 55.3 0 0155.278 55.278z",
  fill: "#ffca0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 114",
  d: "M199.49 189.258a33.167 33.167 0 1033.167 33.167 33.121 33.121 0 00-33.167-33.167z",
  fill: "#ffe478"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 115",
  d: "M155.268 189.258a33.167 33.167 0 1133.167-33.167 33.2 33.2 0 01-33.167 33.167z",
  fill: "#ed6c7b"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 116",
  d: "M243.713 189.258a33.167 33.167 0 1133.167-33.167 33.2 33.2 0 01-33.167 33.167z",
  fill: "#6cbbed"
}))));
export default SvgMultiFamily;